import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { Box, Card, Tooltip } from "@mui/material";
import { formatDate } from "../../../../utils/date-time-utility";
import Flex from "../../../Flex";
import Text from "../../../Text";
import { Alert, AlertMapper } from "./notification-constant";
interface NotificationCardViewProps {
  onRead: () => void;
  notifyData: any;
  ref?: any;
}

const NotificationCardView = ({
  ref,
  onRead,
  notifyData,
}: NotificationCardViewProps) => {
  // const { bg, color, Icon } = notifyData?.result
  //   ? AlertMapper[notifyData?.result as Alert]
  //   : { bg: "#eeeeee", color: "info.main", Icon: NotificationsNoneRoundedIcon };

  const { Icon } = notifyData?.result
    ? AlertMapper[notifyData?.result as Alert]
    : { Icon: NotificationsNoneRoundedIcon };

  const bg = "primary.light";

  const disabledColor = notifyData?.viewed ? "#eeeeee" : null;

  return (
    <Card
      elevation={5}
      variant={"outlined"}
      sx={{
        cursor: !notifyData?.viewed ? "pointer" : "default",
        backgroundColor: disabledColor ?? bg,
        transition: "all 0.2s ease-in-out",
        // color: disabledColor ? "info.main" : color,
        ":hover": !notifyData?.viewed
          ? {
              backgroundColor: "white",
              transform: "translateY(-2px)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }
          : {},
      }}
    >
      <Flex gap={1} p={1.4} ref={ref}>
        <Icon fontSize="medium" color={"primary"} />

        <Box>
          <Text c="dimmed">{notifyData?.title}</Text>
          <Flex width={"100%"} justifyContent={"end"} gap={0.5}>
            <Text c={"info.main"}>{notifyData?.createdBy}</Text>
            <Text c={"info.main"}>
              {notifyData?.createdAt ? formatDate(notifyData?.createdAt) : ""}
            </Text>
          </Flex>
        </Box>

        {!disabledColor && (
          <Tooltip title={"Mark as read"} placement="top" arrow>
            <DraftsOutlinedIcon
              fontSize="small"
              sx={{ color: "info.main", cursor: "pointer" }}
              onClick={() => (!notifyData?.viewed ? onRead() : {})}
            />
          </Tooltip>
        )}
      </Flex>
    </Card>
  );
};

export default NotificationCardView;
